import { PlaceSearchResult } from "@vahak/core/dist/custom-types/location-search";

/** Base route + capacity fields shared by the hero quote form and compact load posting flow. */
export interface LoadQuoteValues {
    source?: PlaceSearchResult;
    destination?: PlaceSearchResult;
    lorryType?: number;
    tonnes?: string;
}

export {
    getLoadQuoteCapacityRange,
    getLoadPostCapacityRangeText,
    getLoadQuoteCapacityStatus,
    getLoadQuoteLorryOptionsForCapacity,
    getLoadQuoteCapacityNumber,
    isLoadQuoteCapacityBoundsReady,
    isLoadQuoteCapacityInRange,
    parseLoadQuoteCapacity,
    type LoadQuoteCapacityStatus
} from "./capacity";
export { getPlaceCityLabel, getPlaceDescriptionLabel } from "./placeLabels";
